export interface IValidation {
    isRegistrationEnabled: boolean,
    useQuickStart: boolean,
    useAdpDefaults: boolean,
    useReducedQuestions: boolean,
    useCystatinC: boolean,
    offerDonorConnect: boolean,
    offerRuleOutTransfer: boolean,
    isDonorConnectLiverEnabled: boolean,
    isDonorConnectNegC: boolean,
    askSexualSocialQuestions: boolean,
    askForId: boolean,
    doRealTimeEval: boolean,
    callbackBusinessDays: boolean,
    dashDonorDaysToExpire: boolean,
    yearsForFollowUpLabs: boolean,
    recipientMaxAge: boolean,
    donorMaxAge: boolean,
    intakeWorkflowConfig: boolean,
    dashDonorDaysToExpireText: boolean,
    dashUsesPwlQuest: boolean,
    dashUsesPwlAtMiles: boolean,
    dashUsesFiveStar: boolean,
    usesPwlForNdd: boolean,
    usesPwlForAdp: boolean,
    usesPwlForLongDistanceDonors: boolean,
    bmiLimit: boolean,
    bmiRequiredForSurgery: boolean,
    bmiLimitLiver: boolean,
    bmiRequiredForSurgeryLiver: boolean,
    minAgeNdd: boolean,
    minAgeDd: boolean,
    mustAcceptBloodTransfusions: boolean,
    ruleOutOnGestationalDiabetes: boolean,
    ruleOutOnKidneyDisease: boolean,
    ruleOutOnHiv: boolean,
    alwaysRuleOutOnHeartAttack: boolean,
    requireQuitTobacco: boolean,
    heartAttackRemissionRequired: boolean,
    diabetesFailLevel: boolean,
    plDashPhoneIsDisplayed: boolean,
    ruleOutOnPregnancy: boolean,
    ruleOutOnPregnancyWaitTime: boolean,
    ruleOutOnNursing: boolean,
    liverRuleOutLiverDisease: boolean,
    liverRuleOutKidneyDisease: boolean,
    liverRuleOutHepB: boolean,
    liverRuleOutHepC: boolean,
    liverRuleOutDiabetes: boolean,
    liverDonorMaxAge: boolean,
    expertSystemAutomated: boolean,
    expireToQueuePostScreening: boolean,
    isStandardVoucherLinkOption: boolean,
    isFamilyVoucherLinkOption: boolean,
    referDonorToNkr: boolean
}